/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserWalletUnFreezeActionReqVo
 */
export interface UserWalletUnFreezeActionReqVo {
    /**
     * 钱包数据编号
     * @type {number}
     * @memberof UserWalletUnFreezeActionReqVo
     */
    id: number;
    /**
     * 解冻金额数量
     * @type {number}
     * @memberof UserWalletUnFreezeActionReqVo
     */
    amount: number;
}

/**
 * Check if a given object implements the UserWalletUnFreezeActionReqVo interface.
 */
export function instanceOfUserWalletUnFreezeActionReqVo(value: object): value is UserWalletUnFreezeActionReqVo {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    return true;
}

export function UserWalletUnFreezeActionReqVoFromJSON(json: any): UserWalletUnFreezeActionReqVo {
    return UserWalletUnFreezeActionReqVoFromJSONTyped(json, false);
}

export function UserWalletUnFreezeActionReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserWalletUnFreezeActionReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'amount': json['amount'],
    };
}

export function UserWalletUnFreezeActionReqVoToJSON(json: any): UserWalletUnFreezeActionReqVo {
    return UserWalletUnFreezeActionReqVoToJSONTyped(json, false);
}

export function UserWalletUnFreezeActionReqVoToJSONTyped(value?: UserWalletUnFreezeActionReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'amount': value['amount'],
    };
}

